import _ from 'lodash';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { getDimensionPostContent } from '../services/DimensionClassService';

export const useDimensionHTMLContent = (postId: string) => {
  const [html, setHtml] = useState('');
  const reader = useMemo(() => new FileReader(), []);
  const [isLoading, setIsLoading] = useState(true);

  const handleLoadEnd = useCallback(() => {
    const unescaped = _.unescape(reader.result as string);
    setHtml(unescaped);
    setIsLoading(false);
  }, [reader.result]);

  useEffect(() => {
    getDimensionPostContent(postId)
      .then((content) => {
        reader.onloadend = handleLoadEnd;
        const blob = new Blob([content], { type: 'text/html' });
        reader.readAsText(blob);
      })
      .catch((e) =>
        console.log(`Failed to render dimension content for ${postId}: ${e}`),
      );
  }, [postId, reader, handleLoadEnd]);

  return { isLoading, html };
};
